export const DEFAULT_RATE = 0.05;

export function daysElapsed(injectionIso) {
  const inj = new Date(injectionIso).getTime();
  const now = Date.now();
  return Math.max((now - inj) / 86400000, 0);
}

export function balanceAt(principal, rate, tDays) {
  return principal * Math.pow(1 + rate, tDays);
}

export function enrich(tranche) {
  const t = daysElapsed(tranche.injection_datetime);
  const rate = tranche.daily_rate ?? DEFAULT_RATE;
  const bal = balanceAt(tranche.principal_amount, rate, t);
  const yesterday = balanceAt(tranche.principal_amount, rate, Math.max(t - 1, 0));
  return {
    ...tranche,
    age_days: t,
    current_balance: bal,
    accrued_yield: bal - tranche.principal_amount,
    todays_profit: bal - yesterday,
  };
}

export function fmtMoney(n, digits = 2) {
  if (n === null || n === undefined || Number.isNaN(n)) return "$0.00";
  return "$" + Number(n).toLocaleString("en-US", {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  });
}

export function fmtCompact(n) {
  return "$" + Number(n).toLocaleString("en-US", {
    notation: "compact",
    maximumFractionDigits: 2,
  });
}

export function ageLabel(days) {
  const d = Math.floor(days);
  const hrs = Math.floor((days - d) * 24);
  return `${d}d ${hrs}h`;
}

// Compounded impact of withdrawn money: it stops earning 5% from the draw date.
export function deductionMetrics(deductions) {
  let impact = 0, todayImpact = 0, raw = 0;
  deductions.forEach((d) => {
    const a = daysElapsed(d.deduction_datetime);
    const rate = d.daily_rate ?? DEFAULT_RATE;
    raw += d.amount;
    impact += d.amount * Math.pow(1 + rate, a);
    todayImpact += d.amount * (Math.pow(1 + rate, a) - Math.pow(1 + rate, Math.max(a - 1, 0)));
  });
  return { raw, impact, todayImpact };
}

// Net portfolio balance `offsetDays` in the past (0 = now).
export function netBalanceAt(tranches, deductions, offsetDays = 0) {
  let gross = 0;
  tranches.forEach((t) => {
    const age = daysElapsed(t.injection_datetime) - offsetDays;
    if (age > 0) gross += balanceAt(t.principal_amount, t.daily_rate ?? DEFAULT_RATE, age);
  });
  let ded = 0;
  deductions.forEach((d) => {
    const age = daysElapsed(d.deduction_datetime) - offsetDays;
    if (age > 0) ded += d.amount * Math.pow(1 + (d.daily_rate ?? DEFAULT_RATE), age);
  });
  return gross - ded;
}
